import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { deletePage } from './actions';
import { getPages } from './reducer';
import { hasMutation } from './utils';

class PageList extends Component {
  deletePage = id => {
    this.props.deletePage(id, 'cs');
  };

  renderTable = () => {
    const { pages } = this.props;

    return pages.map((item, index) => {
      const hasCs = hasMutation(item, 'cs');
      const hasEn = hasMutation(item, 'en');
      return (
        <tr key={index}>
          <td>{hasCs ? item.title.cs : hasEn ? item.title.en : ''}</td>
          <td>
            <Link
              to={{
                pathname: hasCs
                  ? `/zakladni-stranky/edit/${item.id}/cs`
                  : `/zakladni-stranky/new`,
                state: { id: item.id, lang: 'cs', disableSelect: true }
              }}
            >
              {hasCs ? 'Upravit cs' : 'Vytvořit cs'}
            </Link>
          </td>
          <td>
            <Link
              to={{
                pathname: hasEn
                  ? `/zakladni-stranky/edit/${item.id}/en`
                  : `/zakladni-stranky/new`,
                state: { id: item.id, lang: 'en', disableSelect: true }
              }}
            >
              {hasEn ? 'Upravit en' : 'Vytvořit en'}
            </Link>
          </td>
          <td>{item.updated}</td>
        </tr>
      );
    });
  };

  render() {
    const { pages } = this.props;

    if (pages.length === 0) {
      return <div>Žádná základní stránka nebyla vytvořena</div>;
    }

    return (
      <Table>
        <thead>
          <tr>
            <th>Název</th>
            <th>Cs</th>
            <th>En</th>
            <th>Naposledy upraveno</th>
          </tr>
        </thead>
        <tbody>{this.renderTable()}</tbody>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    pages: getPages(state)
  };
};

export default connect(
  mapStateToProps,
  { deletePage }
)(PageList);



// WEBPACK FOOTER //
// ./src/modules/PageList/index.js